import { Image } from 'antd';
import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import useUserStore from '../../stores/store';

function TableImage({color, classes = '', url}) {
    const navigate = useNavigate();
  const { tableManagement } = useUserStore();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }

    if (tableManagement !== 'Active') {
        return ""
    }
    
    return (
        <div className={classes} onClick={onMenuClick}>
            <Image src='/images/icons/daining-table.svg' width={19} height={19} preview={false} />
        </div>
    );
}

export default TableImage;
